import AbstractRequestTask from "../AbstractRequestTask";
import Device from "../../../devices/device";
import Launcher from '../../apa/Launcher';

class ApaAssetTask extends AbstractRequestTask {
  constructor(region = "", appKey = '') {
    super();

    this.region = region;
    this.appKey = appKey;
  }

  getUrl() {
    //return `http://apa-api-tv2sony-test.clarovideo.net/services/apa/asset`;
    return `${Launcher.get("akamai_mfwk")}/services/apa/asset`;
  }

  getParams() {
    const params = super.getParams();

    const appKey = this.appKey ? this.appKey : Device.getDevice().getConfig().appKey;
    const region = this.region || params.region;
    const sessionKey = `${appKey}-${region}`;

    return Object.assign({}, params, { sessionKey } );
  }

  isValid(data = null) {
    return !!data;
  }

  success(data, b) {
    this.resolve(data);
  }

  getRetriesNumber() {
    if (this.appKey) {
      return 0;
    }  
  }
}

export default ApaAssetTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/application/ApaAssetTask.js